import { Link } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import HeroCattle from '../../assets/img/HeroCattle.jpg';

const QUICK_LINKS = [
  { label: 'Facilities',        to: 'facilities-services' },
  { label: 'Service Providers', to: 'service-professionals' },
  { label: 'Market Prices',     to: 'markets-prices' },
];

// Figma column text widths (1134:26617); max widths so the row can shrink
// beside the panel on narrower desktop windows
const EXPLAINERS = [
  { width: 'pub-xl:max-w-[163px]', text: "Explore trusted, published information about Nigeria's livestock sector — by state, species, market and service." },
  { width: 'pub-xl:max-w-[171px]', text: 'Discover trusted, published insights into Nigeria’s livestock sector—by state, species, market, and service.' },
  { width: 'pub-xl:max-w-[192px]', text: 'Access reliable, published information on Nigeria’s livestock industry, organized by state, species, market, and service.' },
  { width: 'pub-xl:max-w-[188px]', text: 'Explore credible livestock information from across Nigeria, covering states, species, markets, and services.' },
];

export default function HeroSection() {
  return (
    <section
      className="public-hero-bg relative overflow-hidden bg-[#103423] bg-cover bg-center"
      style={{ backgroundImage: `url(${HeroCattle})` }}
    >
      {/* 40% black overlay over the photo */}
      <div aria-hidden="true" className="absolute inset-0 bg-[rgba(0,0,0,0.4)]" />

      {/* Figma frame is 823px tall: content starts at 154px (under the
          transparent header) and the explainer row ends at 768px, level
          with the bottom of the right-hand panel. */}
      <div className="relative mx-auto flex max-w-[1440px] flex-col px-4 pb-10 pt-24 sm:px-8 lg:min-h-[823px] lg:px-10 lg:pb-[55px] lg:pt-[154px] pub-xl:px-[100px]">

        <div className="flex flex-1 flex-col pub-xl:max-w-[calc(100%-296px)]">
          <div className="flex flex-col gap-6">
            <h1 className="w-full font-quattrocento text-3xl font-bold leading-tight text-white sm:text-5xl lg:w-[817px] lg:text-[56px] lg:leading-[1.11]">
              National Livestock Information Management{' '}
              <span className="text-[#e7c77e]">System (NLIMS)</span>.
            </h1>

            <p className="w-full text-sm font-medium leading-normal text-white sm:text-base lg:w-[508px] lg:text-[18px]">
              Explore trusted, published information about Nigeria&apos;s livestock sector — by
              state, species, market and service.
            </p>

            {/* Search + Try pills — only the search bar is capped at 436px */}
            <div className="flex flex-col gap-4">
              <form
                role="search"
                onSubmit={(e) => e.preventDefault()}
                className="flex w-full items-center justify-between gap-3 rounded-full bg-[rgba(232,232,232,0.2)] px-5 py-[10px] sm:w-[436px]"
              >
                <div className="flex min-w-0 flex-1 items-center gap-[10px]">
                  <FiSearch className="h-[15px] w-[15px] shrink-0 text-[#a4a4a4]" />
                  <input
                    type="search"
                    placeholder="Search by state, species, market, service..."
                    className="min-w-0 flex-1 bg-transparent text-[13px] font-medium text-white outline-none placeholder:text-[#a4a4a4]"
                  />
                </div>
                <button
                  type="submit"
                  className="shrink-0 rounded-[4px] bg-[#103423] px-[15px] py-2 text-[13px] font-medium text-white transition hover:bg-[#0d2b1c]"
                >
                  Search
                </button>
              </form>

              <div className="flex flex-wrap items-center gap-3">
                <span className="text-[16px] font-normal text-[rgba(241,244,249,0.5)]">Try:</span>
                {QUICK_LINKS.map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    state={link.state}
                    className="whitespace-nowrap rounded-[20px] px-[15px] py-[6px] text-[16px] font-normal leading-normal text-white transition hover:bg-white/10"
                    style={{ border: '0.65px solid rgba(241,244,249,0.5)' }}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Numbered explainer columns — pinned to the bottom of the hero */}
          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-auto lg:pt-12 pub-xl:flex pub-xl:items-start">
            {EXPLAINERS.map(({ width, text }, i) => (
              <div key={text} className="flex min-w-0 flex-col gap-4 border-l border-[#108843] px-[10px]">
                <p className="text-[18px] font-medium leading-normal text-white">/{i + 1}</p>
                <p className={`text-[13px] font-medium leading-normal text-white ${width}`}>{text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right translucent panel — beside the content on wide screens, below it otherwise */}
        <div className="mt-10 pub-xl:absolute pub-xl:right-[90px] pub-xl:top-0 pub-xl:mt-0 pub-xl:flex pub-xl:h-[768px] pub-xl:w-[272px] pub-xl:flex-col pub-xl:justify-end pub-xl:bg-[rgba(255,255,255,0.15)]">
          <div className="flex w-full flex-col items-start gap-6 bg-[#103423] px-6 py-[10px] sm:w-[272px]">
            <p className="w-[192px] text-[13px] font-medium leading-normal text-white">
              Need more information? Contact your state coordinator today.
            </p>
            <Link
              to="contact-us"
              className="rounded-[20px] bg-[#1fc16b] px-[10px] py-[5px] text-[10px] font-medium text-white transition hover:bg-[#19a95c]"
            >
              Contact Us
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
